import type { AbVariant } from '@/wabunka-src/common/core/abVariant/mapOptimizeNextPattern';

/**
 * QA / E2E 用に A/B バリアントを URL クエリ（`?ab=variant` / `?ab=control`）で強制するための純粋ロジック。
 *
 * Vue/Nuxt に一切依存しない（core/ 配下）。Vitest でテストする。
 *
 * 本番・ステージングでは**常に null（強制無効）**を返し、開発・ローカル環境でのみ強制を許可する。
 * これにより本番ユーザーが `?ab=` でデザイン出し分けを操作することを防ぐ。env が未定義（取得失敗）の
 * 場合も null を返す fail-safe 設計とする（許可 env を allowlist で限定）。
 *
 * - env が `development` / `local` 以外（`production` / `staging` / undefined 等） → null
 * - `abQuery` が `'variant'` → `'variant'`
 * - `abQuery` が `'control'` → `'control'`
 * - それ以外（undefined / 配列 / 不正値） → null
 */
const OVERRIDE_ALLOWED_ENVS = ['development', 'local'] as const;

export const resolveAbOverride = (env: string | undefined, abQuery: unknown): AbVariant | null => {
  if (!env || !OVERRIDE_ALLOWED_ENVS.includes(env as (typeof OVERRIDE_ALLOWED_ENVS)[number])) return null;
  if (abQuery === 'variant') return 'variant';
  if (abQuery === 'control') return 'control';
  return null;
};
